var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var _ = function () { };
export var getApplicationsQuery = function (params) {
    var _a = params.limit, limit = _a === void 0 ? 200 : _a, search = params.search, _b = params.sortField, sortField = _b === void 0 ? "providedAt" : _b, _c = params.sortMethod, sortMethod = _c === void 0 ? "DESC" : _c, rest = __rest(params, ["limit", "search", "sortField", "sortMethod"]);
    return __assign({ limit: limit, sort: [{ field: sortField, method: sortMethod }], search: search && search.length > 0 ? search : undefined }, rest);
};
